export enum NotificationTypes {
  procedureFinishedDocumentationFinished = 'procedureFinishedDocumentationFinished',
  procedureActiveDocumentationFinished = 'procedureActiveDocumentationFinished',
  procedureFinishedDocumentationStarted = 'procedureFinishedDocumentationStarted',
  procedureDoctorStarted = 'procedureDoctorStarted',
}
